<template>
  <div v-on-clickaway="exitEditMode" class="drop-element">
    <div class="top-action" style="left: 59%;width:100px;" v-if="!childElements.length">
      <div class="my-btn-group">
        <b-button-group>
          <b-button class="el-move-action" v-b-popover.hover.left="`Déplacer l'élément`"><font-awesome-icon :icon="['fas', 'expand-arrows-alt']" /></b-button>
<!--          <b-button-->
<!--                  @click="openEditElementModal({element: data, elindex})"-->
<!--          >-->
<!--            <font-awesome-icon :icon="['fas', 'edit']" /></b-button>-->
          <b-button
                  @click="deleteElement"
          ><font-awesome-icon :icon="['fas', 'trash-alt']" /></b-button>
        </b-button-group>
      </div>
    </div>
    <draggable class="drop-content" @change="handleAddData" :list="childElements" group="tableauColonne">
      <span v-on-clickaway="away" @click="showControls" v-if="!childElements.length" style="font-size:13px;">Glissez puis déposez des éléments depuis la colonne de gauche </span>
      <bloc-donnees-element v-else :element="this.data" class="center" :con-index="conIndex" :col-index="colIndex" :elindex="elindex" />
    </draggable>
    <edit-element

      ref="editElement"
      />
  </div>
</template>

<script>
import editElement from '../modal/editElement'
import draggable from 'vuedraggable'
import { mapGetters, mapActions } from 'vuex'
import { directive as onClickaway } from 'vue-clickaway'
import { removeHtmlTag } from '../../../utils/util'
import blocDonneesElement from '../display/blocDonneesElement'

export default {
  directives: {
    onClickaway: onClickaway
  },
  components: {
    draggable,
    editElement,
    blocDonneesElement
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    elindex: Number,
    conIndex: Number,
    colIndex: Number
  },
  data () {
    return {
      childElements: null,
      isEdit: false
    }
  },
  beforeMount () {
    this.childElements = this.data.childElements
  },
  watch: {
    data: {
      handler (newValue) {
        this.childElements = newValue.childElements
      },
      deep: true
    }
  },
  methods: {
    ...mapGetters(['getFicheInfo']),
    ...mapActions(['updateSelectedCellValue', 'addDroppedHeader']),
    showControls (e) {
      if (e.target.closest('.drop-content').previousSibling) {
        e.target.closest('.drop-content').previousSibling.previousSibling.classList.remove('d-none')
      }
    },
    away (e) {
      if (e.target.closest('.drop-content').previousSibling) {
        e.target.closest('.drop-content').previousSibling.previousSibling.classList.add('d-none')
      }
    },
    deleteElement () {
      this.$emit('deleteElement', this.elindex)
    },
    handleAddData (data) {
      this.childElements = this.childElements.filter(el => el.key !== data.added.element.key)

      this.childElements.push(data.added.element)
      this.$emit('dropEdit', {elindex: this.elindex, value: this.childElements})
      this.addDroppedHeader(data.added.element.key)
      this.$emit('updateData', { headerKey: data.added.element.key, value: true })
    },
    exitEditMode () {
      if (this.isEdit) {
        this.isEdit = false
      }
    },
    openEditElementModal (data) {
      this.$refs['editElement'].open(data)
    },
    handleDataValueChange (key) {
      this.$refs[`input-${key}`][0].blur()
      const { ligne, onglet } = this.getFicheInfo()
      const payload = {
        onglet,
        lig: ligne,
        headerKey: key,
        valeur: removeHtmlTag(this.$refs[`input-${key}`][0].innerHTML).trim()
      }
      this.updateSelectedCellValue(payload)
    }
  }
}
</script>

<style lang="scss" scoped>
  .btn-group {
    padding: 2px;
    background: #9395C1;
  }
  .btn-group.inactive {
    background: #7F7F7F;
  }
  .drop-element{
    /*padding: 20px 0;*/
    padding-bottom:0;
    /*margin-bottom: 20px;*/
    /*border: 2px dashed #2b3085;*/
    position: relative;
    box-sizing: border-box;
    width: 100%;
    /*background-color: #FFF;*/
    /*text-align: center;*/
    font-size: 14px;
    .el-move-action{
      cursor: move;
    }
    .data-move-action{
      cursor: move;
    }
    .center{
      margin: auto;
    }
    .top-action {
      position: absolute;
      top: 0;
      right: 0;
      height: 25px;
      margin-bottom: 20px;
      text-align: right;
      /*background-color: #d2d3e5;*/
      width: 100%;
      button{
        background-color: transparent;
        border: none;
        color: #2b3085;
        border-radius: 0;
        font-weight: normal;
        box-shadow: none !important;
        padding-left: 5px;
        padding-right: 5px;
        height: 25px;
        line-height: 25px;
        margin-top: -2px;
        &:hover{
          color: #2b3085;
        }
        &:active{
          background-color: #2b3085;
          color: #fff;
        }
      }
    }
    .drop-content{
      /*margin-top: 20px;*/
      /*font-style: italic;*/
      color: rgba($color: #000000, $alpha: 0.4);
      /*font-weight: bold;*/
      font-size: 16px;
      table{
        tr{
          font-size: 14px;
          td:first-child{
            text-align: right;
            color: #444444;
            line-height: 23px;
          }
          td:last-child{
            padding-left: 10px;
            text-align: left;
            color: #2b3085;
            line-height: 23px;
          }
        }
      }
    }
    .drop-edit{
       margin-top: 20px;
       table{
         th{
           background-color: #4789B0;
           color: #FFF;
         }
         tfoot{
           text-align: right;
         }
       }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/edit/elementDrop.vue